import { SEARCH_COLUMN } from '@/constant';

export const OPTIONS_FILTER_DESC = [
	{ name: 'Giá từ thấp đến cao', value: SEARCH_COLUMN.ASC },
	{ name: 'Giá từ cao xuống thấp', value: SEARCH_COLUMN.DESC },
];
